import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-header-search-button",
  templateUrl: "./header-search-button.component.html",
  styleUrls: ["./header-search-button.component.scss"],
})
export class HeaderSearchButtonComponent {
  @Input() searchPlaceholder = "";
  @Output() searchInput = new EventEmitter<any>();

  onSearch(event: any) {
    this.searchInput.emit(event);
  }
}
